import { WarningFilled } from '@ant-design/icons';
import styles from './errorIcon.module.less';

export default function ErrorIcon() {
	return <WarningFilled className={styles.errorIcon} />;
}
